module.exports = __webpack_public_path__ + "img/fullscreen_img.0504f301.png";